import { render } from "./preference-value.vue?vue&type=template&id=983f5fc0&scoped=true"
import script from "./preference-value.vue?vue&type=script&lang=js"
export * from "./preference-value.vue?vue&type=script&lang=js"

import "./preference-value.vue?vue&type=style&index=0&id=983f5fc0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/iam-atkomst-web/iam-atkomst-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-983f5fc0"]])

export default __exports__